/**
 * Tax-field mapping between the country-config tax sublabels and the fixed
 * expense tax columns.
 *
 * India uses a 3-part GST (cgst/sgst/igst). Single-tax countries (e.g. UK VAT)
 * use the dedicated `vatAmount` field. Which UI renders is driven by the
 * country config's `taxSublabels` so labels always match the vendor's country.
 */
export const GST_COLUMNS = ['cgst', 'sgst', 'igst'] as const;
export type GstColumn = (typeof GST_COLUMNS)[number];

/** True for single-tax countries (e.g. UK VAT) rather than multi-part GST. */
export function isSingleTax(taxSublabels: string[] | undefined): boolean {
  return !taxSublabels || taxSublabels.length <= 1;
}

/** The single-tax label (e.g. "VAT"). */
export function singleTaxLabel(taxSublabels: string[] | undefined): string {
  return taxSublabels?.[0] || 'VAT';
}
